import { IInputText } from './types'
import { StyledIconSearch, StyledTextField } from './styles'

export default function SearchInput({
  placeholder,
  onValueChange,
  value,
  id
}: IInputText) {
  function handleValueChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value
    onValueChange(value)
  }

  return (
    <StyledTextField
      id={id}
      className="input-text"
      label={placeholder}
      value={value}
      onChange={handleValueChange}
      slotProps={{
        input: {
          endAdornment: <StyledIconSearch />
        }
      }}
    />
  )
}
